var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99961 1.16634C7.11919 1.16634 7.23352 1.21534 7.31577 1.30167L10.3783 4.51001C10.6437 4.78767 10.4465 5.24967 10.0621 5.24967L8.45794 5.24967L8.45794 8.60384C8.45794 9.00576 8.13069 9.33301 7.72877 9.33301L6.27044 9.33301C5.86852 9.33301 5.54127 9.00576 5.54127 8.60384L5.54127 5.24967L3.93711 5.24967C3.55269 5.24967 3.35552 4.78767 3.62094 4.51001L6.68344 1.30167C6.76569 1.21534 6.88002 1.16634 6.99961 1.16634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02083 10.3337L12.9792 10.3337C13.5421 10.3337 14 10.7916 14 11.3545L14 11.6462C14 12.2091 13.5421 12.667 12.9792 12.667L1.02083 12.667C0.457917 12.667 4.00322e-08 12.2091 8.92437e-08 11.6462L1.14742e-07 11.3545C1.63953e-07 10.7916 0.457917 10.3337 1.02083 10.3337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(14 14) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e2c591ff.svg";
export { ForwardRef as ReactComponent };